// Control de stock de la sucursal (acciones pendientes del dashboard).
// `modulo: 'productos'` + permiso dejan que un encargado la abra tambien desde
// el contexto empresa; sin eso el guard lo devuelve al POS.
export default [
  {
    path: 'control-stock',
    name: 'empresa.sucursal.alertas.stock',
    component: () => import('@/views/inventario/AlertasStockControl.vue'),
    meta: {
      requiresAuth: true,
      modulo: 'productos',
      permisos: ['realizar_inventario', 'modificar_stock'],
    },
  },
];
